<template>
  <div>
    <div id="mySidenav" class="sidenav" style="left: 0px;">
      <div class="card-header m-0 font-bold">
        Suchen und Filtern
      </div>
      <div id="sidebar" class="px-2 py-2">
        <div>
          <label class=" formfont">E-Mail / Name / Firma:</label>
          <div class="col-12 input-group mb-3 p-0">
            <input placeholder="E-Mail / Name / Firma" data-on-color="success" type="text" name="name" required="required" class="form-control font12" v-model="filters.name">
          </div>
        </div>
        <div>
          <label class=" formfont">Projektzugehörigkeit:</label>
          <div class="col-12 input-group mb-3 p-0">
            <input placeholder="" data-on-color="success" type="text" name="name" required="required" class="form-control font12" v-model="filters.project">
          </div>
        </div>
        <div class="switch mb-2">
          <label class="w-100 formfont"> Projekte erstellen:
          <input type="checkbox" id="customSwitch1" class="custom-control-input" v-model="filters.creator" :true-value="1" :false-value="''">
            <span class="lever float-right mr-0"></span>
          </label>
        </div>
        <div class="switch">
          <label class="w-100 formfont"> Kundenadmin:
          <input type="checkbox" id="customSwitch1" class="custom-control-input" v-model="filters.customer_admin" :true-value="1" :false-value="''">
            <span class="lever float-right mr-0"></span>
          </label>
        </div>

<!--        <div>-->
<!--          <h2>Filterwerte</h2>-->
<!--          A: {{ filters.name }}<br />-->
<!--          B: {{ filters.project }}<br />-->
<!--          C: {{ filters.creator }}<br />-->
<!--          D: {{ filters.customer_admin }}-->
<!--        </div>-->

      </div>
    </div>

    <div class="main-content main-customer font1rem minheight100">
      <!-- one tab -->
      <div class="conatiner-fluid d1" id="DataA">
        <div class="row">
          <div class="col-sm-12 pl-1 pr-1 py-2">

            <table class="w-100 table ">
              <thead>
                <tr>
                  <th></th>
                  <th>E-Mail</th>
                  <th>Vorname</th>
                  <th>Nachname</th>
                  <th>Firma</th>
                  <th class="text-center">Projekte</th>
<!--                  <th>Status</th>-->
                  <th class="text-center">in Kundenbenutzerliste<br />anzeigen</th>
                  <th class="text-center">Projekte erstellen</th>
                  <th class="text-center">Kunden Admin</th>
                </tr>
              </thead>
              <tbody>

              <tr v-for="(item,index) in customerusers">
                <td><a href="#" @click="projectlistmodal(item)"><i class="fa fa-list"></i></a></td>
                <td>{{ item.email }}</td>
                <td>{{ item.firstname }}</td>
                <td>{{ item.lastname }}</td>
                <td>{{ item.company }}</td>
                <td class="text-center" :data-projectids="item.projectids"><a href="#" @click="projectlistmodal(item)">{{ item.projectcount }}</a></td>
<!--                <td>{{ item.status }}</td>-->
                <td class="text-center">
                  <div class="switch ">
                    <label class="">
                    <input type="checkbox" :id="'creator' + item.pduserid" class="custom-control-input" v-model="item.iscustomeruser" :true-value="1" :false-value="0" @change="setCustomerUser($event, item)"">
                    <span class="lever float-right mr-0"></span>
                    </label>
                  </div>
                </td>
                <td class="text-center">
                  <div class="switch ">
                    <label class="">
                    <input type="checkbox" :id="'creator' + item.pduserid" class="custom-control-input" v-model="item.creator" :true-value="1" :false-value="0" @change="setCreator($event, item)">
                    <span class="lever float-right mr-0"></span>
                    </label>
                  </div>
                </td>
                <td class="text-center">
                  <div class="switch ">
                    <label class="">
                      <input type="checkbox" :id="'creator' + item.pduserid" class="custom-control-input" v-model="item.customer_admin" :true-value="1" :false-value="0" @change="setCustomerAdmin($event, item)">
                      <span class="lever float-right mr-0"></span>
                    </label>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Projects-Modal v-if="showprojectmodal" :useritem="useritem" @closeModal="showprojectmodal = false" :customerid="customerid"></Projects-Modal>
  </div>

</template>
<script>
import axios from '../../../utils/axiosinstance'
// import axios from 'axios'
import ProjectsModal from './ProjectsModal.vue'

export default {
  name: 'users',
  components: {
    ProjectsModal: ProjectsModal
  },

  data () {
    return {
      'area': 'users',
      'customerid': '',
      'useritem': {},
      'showprojectmodal': false,
      'customerusers': [],
      localtoast: null,
      filters: {
        name: '',
        project: '',
        creator: '',
        customer_admin: ''
      }
    }
  },

  mounted () {
    this.customerid = this.$route.params.customerid
    this.fixElementHeights()
    console.log('USERS MOUNTED')
    this.customerusers = []
    this.getcusttomerusers()
  },

  methods: {

    fixElementHeights () {
      let headerheight = $('header').height()
      $('#mySidenav, .main-content').css({'top': headerheight})
      $('.main-content').css({'margin-left':'210px'})
      $('#mySidenav').css({'height':'calc(100vh - '+headerheight+'px)'});
      console.log('sidenavheight', headerheight)
    },

    projectlistmodal (item) {
      console.log('Show Modal for item', item)
      this.useritem = item
      this.showprojectmodal = true

    },

    getCheckboxValue(item) {
      if(item == '1') {
        return true
      }
      return false
    },

    async setCustomerUser(event, item) {
      let _this = this

      let params = [
        _this.$route.params.customerid,
        item.pduserid,
        item.iscustomeruser
      ];

      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: params,
        serviceName: "ProjectdocuCustomer",
        methodName: "updateusersiscustomer"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {

        if(response.data == true) {
          _this.localtoast = _this.$toast(
            'Gespeichert.',
            {
              timeout: 2000,
              closeOnClick: true,
              toastClassName: "savenote",
            }
          )
        }
      }).catch(e => {
        console.log('ERROR EXECUTION')
      });

    },

    async setCreator (event, item) {
      console.log('Change Creator value', event, item)
      console.log('CUSER:', this.customerusers)
      let _this = this

      let params = [
        _this.$route.params.customerid,
        item.pduserid,
        item.creator
      ];

      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: params,
        serviceName: "ProjectdocuCustomer",
        methodName: "updatecustomeruserscreator"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {

        if(response.data == true) {
          _this.localtoast = _this.$toast(
            'Gespeichert.',
            {
              timeout: 2000,
              closeOnClick: true,
              toastClassName: "savenote",
            }
          )
        }
      }).catch(e => {
        console.log('ERROR EXECUTION')
      });



    },

    async setCustomerAdmin (event, item) {
      console.log('Change CustomerAdmin value updatecustomeruserscustomeradmin', event, item)
      console.log('Change Creator value', event, item)
      console.log('CUSER:', this.customerusers)
      let _this = this

      let params = [
        _this.$route.params.customerid,
        item.pduserid,
        item.customer_admin
      ];

      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: params,
        serviceName: "ProjectdocuCustomer",
        methodName: "updatecustomeruserscustomeradmin"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {

        if(response.data == true) {
          _this.localtoast = _this.$toast(
            'Gespeichert.',
            {
              timeout: 2000,
              closeOnClick: true,
              toastClassName: "savenote",
            }
          )
        }
      }).catch(e => {
        console.log('ERROR EXECUTION')
      });
    },


    async getcusttomerusers() {
      let _this = this
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [_this.$route.params.customerid, _this.filters],
        serviceName: "ProjectdocuCustomer",
        methodName: "getcustomerusers"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        console.log(response)
        if(response.data == false) {
          // Do Nothing because is not admin!
        } else {
          _this.customerdata = response.data
          console.log('CUSTOMER_DATA', _this.customerdata)
          _this.customerusers = response.data.users
          _this.customerusers.forEach(function(val, idx) {
            // val.customer_admin = (val.customer_admin == '1') ? 1 : 0;
            // val.creator = (val.creator == '1') ? 1 : 0;
          })
        }

        console.log('This', _this.isCustomerAdmin, _this.customers)
      }).catch(e => {
        // localStorage.clear()
        // this.$router.push('/login')
      });
    }

  },

  watch: {
    filters: {
      handler (newData) {
        console.log('Filter', newData)
        this.getcusttomerusers();
      },
      deep: true
    }
  },


  created () {
    console.log('USERS CREATED')
  }
}
</script>




// WEBPACK FOOTER //
// src/components/customer/components/users.vue